// Validation helpers — bewusst pragmatisch, kein Overkill.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(s: string): boolean {
  return EMAIL_RE.test(s.trim());
}

/**
 * IBAN-Validierung nach ISO 13616 (Mod-97-Check).
 * Akzeptiert mit/ohne Whitespace, case-insensitive.
 */
export function isValidIban(input: string): boolean {
  const s = input.replace(/\s+/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(s)) return false;
  // 4 Zeichen ans Ende ziehen, dann Buchstaben → Zahlen (A=10..Z=35), Mod 97
  const rearr = s.slice(4) + s.slice(0, 4);
  let rem = 0;
  for (const ch of rearr) {
    const code = ch.charCodeAt(0);
    const n = code >= 48 && code <= 57 ? code - 48 : code - 55;
    if (n < 0 || n > 35) return false;
    rem = (rem * (n > 9 ? 100 : 10) + n) % 97;
  }
  return rem === 1;
}

export function normalizeIban(input: string): string {
  return input.replace(/\s+/g, '').toUpperCase();
}

/** Lockerer Telefon-Check: 6–20 Ziffern, optionales +, Leerzeichen/Bindestriche erlaubt. */
export function isValidPhone(s: string): boolean {
  if (!s.trim()) return true;
  return /^\+?[\d\s\-/().]{6,25}$/.test(s.trim());
}

export function isValidPlz(s: string): boolean {
  if (!s.trim()) return true;
  return /^\d{4}$/.test(s.trim());
}
